module.exports = {"sorry":"Beklager, noget gik galt.","tryagain":"Genindlæs"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/da-DK/strings.json
// module id = 1174
// module chunks = 0